import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomePage.vue"),
  },
  {
    path: "/corporate-profile",
    name: "CorporateProfile",
    component: () => import("../views/CorporateProfile.vue"),
  },
  {
    path: "/opportunities",
    name: "Opportunities",
    component: () => import("../views/OpportunitiesViewInfinite.vue"),
  },
  {
    path: "/opportunities/:opp_id",
    name: "OpportunityPage",
    component: () => import("../views/OpportunityPage.vue"),
  },
  {
    path: "/events",
    name: "Events",
    component: () => import("../views/EventsViewInfinite.vue"),
  },
  {
    path: "/events/:event_id",
    name: "EventPage",
    component: () => import("../views/EventPage.vue"),
  },
  {
    path: "/register-event",
    name: "RegisterEvent",
    component: () => import("../views/RegisterEvent.vue"),
  },
  {
    path: "/register-opportunity/:opp_name(.+)", // adding (.*) for param value that includes "/"
    name: "RegisterOpportunity",
    component: () => import("../views/RegisterOpportunity.vue"),
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: () => import("../views/ContactUs.vue"),
  },
  {
    path: "/terms-and-conditions",
    name: "Terms&Conditions",
    component: () => import("../views/TermsConditions.vue"),
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
  },
];


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition){
    if(to.hash){
      // /page#hash_id go to that section
      return {el: to.hash, top: 0, behavior: 'smooth'}
    } else {
      // new page start from the top
      return {top: 0}
    }
    // --------------------------------------
    // new page start from the top
    // return {top: 0}
  }
});

export default router;
